import React from "react";
import { useLanguageContent } from "../Components/LangueContentLoader";
import MouseTrail from "../Components/MouseTrail";

export default function Experience() {
  const content = useLanguageContent();
  return (
    <div id="Experience-page">
      <MouseTrail />
      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2024-2025</div>
          <div>{content.resumeSection.alternance}</div>
          <div>Chez Ugo & Léa, Dreux (28100) </div>
          <div>ESCCI, Evreux (27000)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>
      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2022-2024</div>
          <div>{content.resumeSection.devDiploma}</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>
      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2023</div>
          <div>Nova-SEO ({content.resume.month6})</div>
          <div> {content.commercial} </div>
          <div>Normandie (14, 27, 50, 61, 76)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2022</div>
          <div>Opinel France ({content.resume.month7})</div>
          <div>{content.agentMontage}</div>
          <div>Chambéry (73)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2021</div>
          <div>Le RDC Discothèque ({content.resume.month3})</div>
          <div>
            {content.serveur}/{content.barman}
          </div>
          <div>Chambéry (73)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2019/2020</div>
          <div>L'Ancolie**** ({content.resume.year1})</div>
          <div>
            {content.serveur}/{content.maitreDho}
          </div>
          <div>Cruseilles (74)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2019</div>
          <div>- Les Servages d'Armelle**** ({content.resume.month4})</div>
          <div>{content.chefDeRang}</div>
          <div>Les Carroz d'Arraches (74)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2018/2019</div>
          <div>Au Bureau ({content.resume.month4})</div>
          <div>{content.chefDeRang}</div>
          <div>Val De Reuil (27)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2018</div>
          <div>Columbus hôtel**** ({content.resume.month2})</div>
          <div>{content.manager}</div>
          <div>Monaco</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2016/2018</div>
          <div>Au Bureau ({content.resume.year2})</div>
          <div>{content.chefDeRang}</div>
          <div>Annecy (74)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2015</div>
          <div>
            Intérimaire, Multiples hôtels 5 étoiles ({content.resume.month6})
          </div>
          <div>
            {content.chefDeRang}/{content.barman}/{content.traiteur}
          </div>
          <div>{content.geneva}</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2015</div>
          <div>Impérial Palace**** ({content.resume.month6})</div>
          <div>{content.chefDeRang}</div>
          <div>Annecy (74)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2014</div>
          <div>L'auberge du Lyonnais ({content.resume.year1})</div>
          <div>{content.serveurPo}</div>
          <div>Annecy (74)</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2013</div>
          <div>Hôtel Belle Pierre**** ({content.resume.year1})</div>
          <div>{content.serveur}</div>
          <div>{content.LaReunion}</div>
        </div>
      </div>
      <div class="ligne-verticale"></div>

      <div class="experience">
        <div class="single-exp-box">
          <div class="annee">2010/2012</div>
          <div>Thaï-Savanh' ({content.resume.year2})</div>
          <div>{content.serveurPo}</div>
          <div>{content.SXM}</div>
        </div>
      </div>
    </div>
  );
}
